/**
 * Функция для получения цены с учетом разных типов объектов
 * @param {Object} details - Объект с деталями, содержащий различные поля цен
 * @returns {Object} Объект с полями value (форматированная цена) и suffix (суффикс)
 */
export const getPrice = (details) => {
  // Массив с возможными полями цен и их суффиксами
  const priceFields = [
    { field: 'price', suffix: '₽' },
    { field: 'rent_per_day', suffix: '₽/день' },
    { field: 'rent_per_month', suffix: '₽/мес' },
    { field: 'rent_in_month', suffix: '₽/мес' }

    // Сюда можно легко добавлять новые типы цен
  ];

  // Проверка на наличие объекта details
  if (!details) {
    return { value: '', suffix: '' };
  }
  
  // Ищем первое существующее поле цены
  for (const { field, suffix } of priceFields) {
    if (details[field] !== undefined) {
      // Защищаемся от null или undefined
      const value = details[field];
      if (value === null) {
        continue;
      }
      
      return {
        value: value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' '),
        suffix
      };
    }
  }
  
  // Если ничего не найдено, возвращаем пустую строку
  return { value: '', suffix: '' };
};

/**
 * Форматирует числовое значение для отображения в интерфейсе
 * @param {number|string} value - Числовое значение для форматирования
 * @returns {string} Отформатированная строка с разделителями тысяч
 */
export const formatNumber = (value) => {
  if (value === undefined || value === null) return '';
  return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
}; 